<app-select
    [(ngModel)]="value"
    [label]="label"
    [options]="options"
    [loading]="loading"
    [id]="id"
></app-select>